import HorizontalScroller, { smartLeftScroller, smartRightScroller } from './HorizontalScroller'

export { smartLeftScroller, smartRightScroller }
export default HorizontalScroller
